import { useAuthContext } from '@/contexts/auth-context';

/**
 * Accounts without a Source subscription. The flag is only present (and true)
 * for free-tier accounts, so its absence means the account is subscribed.
 */
const SOURCE_FREEMIUM_FLAG = 'source-freemium';

export function useSourceFreemium(): boolean {
  const { whoami } = useAuthContext();

  return whoami?.feature_flags?.[SOURCE_FREEMIUM_FLAG] === true;
}
